// Flow Planner rollout. A site is enabled when its country is listed, or when the site
// itself is listed. Country enables every site in it; the site list is for enabling
// individual sites in countries that are not fully rolled out. EXCLUDED_SITES wins over
// both, so a site can be held back even when its country is enabled.
export const FLOW_PLANNER_COUNTRIES = [];
export const FLOW_PLANNER_SITES = [
  'DII3',
  'DAS8',
  'DAX5',
  'DTN7',
  'DAU2',
  'DTB9',
  'DWA9',
  'DMD8',
  'DIL7',
  'DMI9',
  'DTN8',
  'DAB4',
  'DAS7',
  'DBK1',
  'DDA9',
  'DDP9',
  'DFO9',
  'DFT4',
  'DFX3',
  'DIL5',
  'DIN6',
  'DLD7',
  'DLX9',
  'DMS2',
  'DNK7',
  'DON3',
  'DPP1',
  'DSC3',
  'DYB2',
  'DYN5',
  'DYN9',
  'DSK4',
  'DLT2',
  'DLT6',
  'DLT7',
  'DRT3',
  'DTR7',
  'DRT8',
  'DRT9',
  'DDW7',
  'DGI3',
  'DMD9',
  'DFL3',
  'DBL1',
  'DCY1',
  'DCY9',
  'DEB2',
  'DOB2',
  'DOB4',
  'DYO5',
  'DBO6',
  'DLX5',
  'DWD6',
  'DSD8',
  'DSD5',
  'DLC8',
  'DAU7',
  'DRK3',
  'DJT6',
  'DIB6',
  'DAB5',
  'DAT9',
  'DBA5',
  'DBA7',
  'DBA8',
  'DBK4',
  'DBK6',
  'DBL8',
  'DCD6',
  'DCX2',
  'DCX8',
  'DDC3',
  'DDC4',
  'DDC9',
  'DDF2',
  'DDF4',
  'DDM5',
  'DDT3',
  'DDT4',
  'DDT6',
  'DDT9',
  'DDW1',
  'DDX7',
  'DEW5',
  'DFH1',
  'DFL4',
  'DFL5',
  'DFL8',
  'DFX9',
  'DGE7',
  'DGR3',
  'DHO3',
  'DHO7',
  'DHO8',
  'DHT1',
  'DHT4',
  'DHX1',
  'DHX4',
  'DIA3',
  'DIA5',
  'DIB5',
  'DIB7',
  'DJE1',
  'DJE2',
  'DJE3',
  'DJE5',
  'DJZ2',
  'DJZ4',
  'DJZ6',
  'DKS3',
  'DLB2',
  'DLC1',
  'DLC4',
  'DLD1',
  'DLI3',
  'DLN2',
  'DLN4',
  'DLT3',
  'DLT8',
  'DLX7',
  'DMC3',
  'DMC4',
  'DMD2',
  'DMD4',
  'DMD5',
  'DMD6',
  'DMF3',
  'DMO3',
  'DMO4',
  'DMO6',
  'DNA4',
  'DNA6',
  'DNO2',
  'DNO3',
  'DOK2',
  'DOK6',
  'DOR2',
  'DOR3',
  'DPH7',
  'DPL2',
  'DPL7',
  'DRC6',
  'DRT4',
  'DRT7',
  'DSD1',
  'DSD4',
  'DSW3',
  'DTG5',
  'DTN6',
  'DTY7',
  'DUR9',
  'DVA2',
  'DVA3',
  'DVA5',
  'DVB4',
  'DVB5',
  'DVB7',
  'DWA2',
  'DWA5',
  'DWA6',
  'DWS4',
  'DXH1',
  'DXH5',
  'DXT2',
  'DYN3',
  'DYN7',
  'DYO2',
  'DYY4',
  'DYY5',
  'DYY8',
  'DAB8',
  'DAE1',
  'DAE3',
  'DAE7',
  'DAE8',
  'DAS9',
  'DAU5',
  'DAX3',
  'DAX7',
  'DAX8',
  'DAZ2',
  'DAZ4',
  'DBC3',
  'DBM5',
  'DBO7',
  'DBO9',
  'DBU1',
  'DBU2',
  'DBU3',
  'DBU7',
  'DBU9',
  'DCB4',
  'DCB8',
  'DCG2',
  'DCG4',
  'DCH6',
  'DCH8',
  'DCK1',
  'DCK6',
  'DCL3',
  'DCL4',
  'DCL5',
  'DCL7',
  'DCL9',
  'DCM2',
  'DCM3',
  'DCM5',
  'DCM6',
  'DCN2',
  'DCS3',
  'DCS6',
  'DCW8',
  'DCX5',
  'DCX7',
  'DCY2',
  'DDE8',
  'DDE9',
  'DDF1',
  'DDF5',
  'DDO6',
  'DDP1',
  'DDP3',
  'DDP5',
  'DDV2',
  'DDV3',
  'DDV4',
  'DDV5',
  'DDX2',
  'DDX6',
  'DFA5',
  'DFB1',
  'DFH3',
  'DFH7',
  'DFL7',
  'DFM3',
  'DFM4',
  'DFM5',
  'DFO2',
  'DFO3',
  'DFX4',
  'DGE4',
  'DGE9',
  'DGF1',
  'DGF2',
  'DGR6',
  'DGR8',
  'DGS3',
  'DGT2',
  'DGT8',
  'DHI2',
  'DIA4',
  'DIA6',
  'DID2',
  'DID3',
  'DII4',
  'DII5',
  'DIN4',
  'DIN8',
  'DJC5',
  'DJE9',
  'DJR1',
  'DJR3',
  'DJR5',
  'DJW8',
  'DJX2',
  'DJX3',
  'DJX4',
  'DJZ3',
  'DJZ5',
  'DJZ8',
  'DKC3',
  'DKO1',
  'DKO9',
  'DKY4',
  'DKY5',
  'DKY6',
  'DKY8',
  'DKY9',
  'DLF1',
  'DLI4',
  'DLI5',
  'DLI6',
  'DLI8',
  'DLI9',
  'DLN3',
  'DLN8',
  'DLR2',
  'DLV2',
  'DLV3',
  'DLV4',
  'DLV7',
  'DLX1',
  'DLX8',
  'DMF1',
  'DMF5',
  'DMF8',
  'DMF9',
  'DMH4',
  'DMH9',
  'DMI7',
  'DML3',
  'DML4',
  'DML6',
  'DML8',
  'DMP1',
  'DMP4',
  'DMS6',
  'DMW2',
  'DNH2',
  'DNJ2',
  'DNJ4',
  'DNJ7',
  'DNK2',
  'DNK5',
  'DOB7',
  'DOI2',
  'DOI3',
  'DOI4',
  'DOI5',
  'DOI6',
  'DOK3',
  'DOK4',
  'DOM2',
  'DOM3',
  'DON8',
  'DON9',
  'DOT4',
  'DPD2',
  'DPD4',
  'DPD6',
  'DPD7',
  'DPD8',
  'DPH8',
  'DPH9',
  'DPP7',
  'DPS2',
  'DPS5',
  'DPS6',
  'DPX4',
  'DPX7',
  'DRI1',
  'DRO2',
  'DSC4',
  'DSE8',
  'DSF5',
  'DSF7',
  'DSF8',
  'DSJ5',
  'DSJ9',
  'DSM4',
  'DSR2',
  'DSR4',
  'DSR6',
  'DSR8',
  'DSW5',
  'DSX5',
  'DSX8',
  'DSX9',
  'DTB4',
  'DTO3',
  'DTO5',
  'DTP3',
  'DTP7',
  'DTP9',
  'DTU2',
  'DTU3',
  'DTU6',
  'DTU7',
  'DTU8',
  'DTU9',
  'DTY4',
  'DUA3',
  'DUR1',
  'DUR3',
  'DUT2',
  'DUT4',
  'DUT5',
  'DUT7',
  'DVB8',
  'DVC4',
  'DVH1',
  'DVV2',
  'DVV5',
  'DVY2',
  'DVY7',
  'DWA7',
  'DWI4',
  'DWO1',
  'DWO6',
  'DXC3',
  'DXC5',
  'DXC8',
  'DXH6',
  'DXT8',
  'DXY4',
  'DYB3',
  'DYH1',
  'DYO1',
  'DYR3',
  'DYR7',
  'DYT3',
  'DYT6',
  'DYV1',
  'DYY3',
  'DYY6',
  'DYY9',
  'DZU1',
  'DAV5',
  'DDK6',
  'DFR7',
  'DFR8',
  'DGF5',
  'DGS2',
  'DIO1',
  'DLR6',
  'DOL3',
  'DOZ5',
  'DRN5',
  'DUG2'
];
export const FLOW_PLANNER_EXCLUDED_SITES = [];

export const isFlowPlannerEnabledFor = (countryCode, stationCode) => {
  const station = stationCode ? stationCode.toUpperCase() : null;
  if (station && FLOW_PLANNER_EXCLUDED_SITES.includes(station)) return false;
  const country = countryCode ? countryCode.toUpperCase() : null;
  return (!!country && FLOW_PLANNER_COUNTRIES.includes(country)) || (!!station && FLOW_PLANNER_SITES.includes(station));
};
